import { useEffect, useState } from 'react'
import axios from 'axios'
import to from 'await-to-js'

const useCountryCode = () => {
  const [countryCode, setCountryCode] = useState()

  const fetchCountryCode = async () => {
    const key = 'gremlin__clearbit__countryCode'
    const storage = window.localStorage.getItem(key)

    // Attempt to grab from localStorage first
    if (storage) {
      setCountryCode(storage)
    } else {
      const [, data] = await to(axios.get('/.netlify/functions/country-code'))

      if (data) {
        setCountryCode(data.data)

        // Set localStorage for persistance
        window.localStorage.setItem(key, data.data)
      }
    }
  }

  useEffect(() => {
    fetchCountryCode()
  }, [])

  return countryCode
}

export default useCountryCode
